import { t } from 'i18next';
import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { baseStyles, buttonStyles } from '@/styles';
import { PersonalisationStepId } from '@/types';

@customElement('fg-personalisation-file')
export class FGPersonalisationFile extends LitElement {
  @property({ type: String })
  fileName?: string | null;

  private resetUpload = () => {
    this.dispatchEvent(
      new CustomEvent('personalisation-reset-upload', {
        detail: PersonalisationStepId.UPLOAD_SELECT_FILE,
      }),
    );
  };

  render() {
    if (!this.fileName) {
      return nothing;
    }

    return html`
      <h4>${this.fileName}</h4>
      <button
        class="reset-upload-button"
        @click=${
          () => this.resetUpload() /** TODO: Connect to upload FGCOM-406 */
        }
      >
        ${t('actions.uploadOtherFile')}
      </button>
    `;
  }

  static styles = [
    baseStyles,
    buttonStyles,
    css`
      :host {
        text-align: center;
      }
      h4 {
        margin: 0 0 5px;
        font-size: 1rem;
      }
      .reset-upload-button {
        appearance: none;
        background-color: transparent;
        margin-top: 5px;
        border: none;
        color: var(--fg-primary, var(--fg-fallback-primary));
        text-decoration: underline;
        cursor: pointer;
      }
      .reset-upload-button:hover {
        color: var(--fg-primary--dark, var(--fg-fallback-primary--dark));
      }
    `,
  ];
}
